<template>
  <pt-balance-manage-table class="pt-balance-manage-table__withData" @getBalanceList="getBalanceList" :tableLabels="tableLabels" :page-size="page_size" :tableData="tableData"
  :totalNumber="totalNumber" ref="table" :loading="loading">
      <slot/>
  </pt-balance-manage-table>
</template>

<script>
import PtBalanceManageTable from './index'
export default {
  name: 'pt-balance-manage-table__withData',
  components: {
    'pt-balance-manage-table': PtBalanceManageTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    paramsData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      totalNumber: 0,
      page_size: 10,
      tableData: [],
      loading: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        this.getBalanceList(this.page)
      }
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    getBalanceList (page, next, size) {
      let data = {
        pageable: {
          page: page,
          size: size || this.page_size
          // sort: 'lastModifiedDate,desc'
        },
        ...this.paramsData
      }
      this.loading = true
      this.$store.dispatch('getBalanceList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
        this.loading = false
      }).catch(err => {
        this.$message.error(err || '获取失败')
        this.$refs.table.showReTry()
        this.loading = false
      })
    },
    reload () {
      this.$refs.table.reload()
    }
  }
}
</script>
